import { render, staticRenderFns } from "./RsaGestioneCentroDiurnoRientratiDomicilioComponent.vue?vue&type=template&id=7a266482"
import script from "./RsaGestioneCentroDiurnoRientratiDomicilioComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneCentroDiurnoRientratiDomicilioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports